import { Ancillaries } from "./ancillaries.model";
import { BookedSegmentChoiceCollection } from "./booked-segment-choice-collection.model";
export class BookedTraveler {
  private _id: string;
  private _isSelectedToCheckin: boolean;
  private _overBookingInfo: string;
  private _carryOnChecked: number;
  private _ancillaries: Ancillaries;
  private _segmentChoices: BookedSegmentChoiceCollection;

  constructor(passenger: any) {

    this._id = passenger.id;
    this._isSelectedToCheckin = passenger.checkinSelected;

    if (passenger.isOverBookingEligible) {
    } else {
      if (passenger.isSelectedToCheckin != null) {
        this._isSelectedToCheckin = passenger.isSelectedToCheckin;
      }

      if (passenger.carryOnChecked) {
        this._carryOnChecked = passenger.carryOnChecked;
      }

      this._ancillaries = new Ancillaries(passenger.ancillaries);
      this._segmentChoices = new BookedSegmentChoiceCollection(passenger.segmentChoices);
    }

  }

  get id(): string {
    return this._id;
  }

  set id(id: string) {
    this._id = id;
  }

  get isSelectedToCheckin(): boolean {
    return this._isSelectedToCheckin;
  }

  set isSelectedToCheckin(isSelectedToCheckin: boolean) {
    this._isSelectedToCheckin = isSelectedToCheckin;
  }

  get overBookingInfo(): string {
    return this._overBookingInfo;
  }

  set overBookingInfo(overBookingInfo: string) {
    this._overBookingInfo = overBookingInfo;
  }

  get carryOnChecked(): number {
    return this._carryOnChecked;
  }
  set carryOnChecked(carryOnChecked: number) {
    this._carryOnChecked = carryOnChecked;
  }

  get ancillaries(): Ancillaries {
    return this._ancillaries;
  }

  set ancillaries(ancillaries: Ancillaries) {
    this._ancillaries = ancillaries;
  }

  get segmentChoices(): BookedSegmentChoiceCollection {
    return this._segmentChoices;
  }

  set segmentChoices(segmentChoices: BookedSegmentChoiceCollection) {
    this._segmentChoices = segmentChoices;
  }

  addAncillary(ancillary) {
  }

  addSegmentChoice(segmentChoice) {
    this._segmentChoices.addSegmentChoice(segmentChoice);
  }

  /**
   * Merges a booked traveler into this one
   * @param bookedTraveler traveler to merge
   */
  merge(bookedTraveler) {
    if (bookedTraveler == null || bookedTraveler.id != this.id) {
      throw "Invalid input for merge! ";
    }
    this._isSelectedToCheckin = bookedTraveler.isSelectedToCheckin;
    if (bookedTraveler.ancillaries != null) {
     this._ancillaries.merge(bookedTraveler.ancillaries);
    }
    if (bookedTraveler.segmentChoices != null) {
      this._segmentChoices.merge(bookedTraveler.segmentChoices);
    }
  }

  clearPremiereUpgrade() {
   this._ancillaries.clearPremiereUpgrade();
  }

  clearSeats() {
    this._segmentChoices.clearSeats();
  }

  /**
   * Clears a seat for the matching segment
   * @param segmentCode
   */
  clearSeat(segmentCode) {
    this._segmentChoices.clearSeat(segmentCode);
  }

  clearEmpty() {
    if (!this._ancillaries) {
      this._ancillaries = null;
    } else {
      this._ancillaries.prepareForCall();
    }
    if (this._segmentChoices == null || this._segmentChoices.isEmpty()) {
      this._segmentChoices = null;
    }
  }

  clearAncillaries() {
    this._ancillaries = null;
  }

  getSeatBalance() {
    return this._segmentChoices.getSeatBalance();
  }

  seatHasPaymentDue(segmentCode) {
    if (segmentCode == null) {
      return false;
    }

    let segmentChoice = this._segmentChoices.findSegmentChoice(segmentCode);

    return segmentChoice ? segmentChoice.seat.currency != null : false;
  }

}
